module.exports = __webpack_public_path__ + "img/barrage_prize_01.aad9497d.png";